import { render, staticRenderFns } from "./OutsideManners.vue?vue&type=template&id=6a11a3ae&"
import script from "./OutsideManners.vue?vue&type=script&lang=js&"
export * from "./OutsideManners.vue?vue&type=script&lang=js&"
import style0 from "./OutsideManners.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports